import { getApiUrl } from './get-api-url';

export const authHeader = (): Promise<any> => {
    const urlParams = new URLSearchParams(window.location.search);

    const operatorId = urlParams.get('operator');
    const authToken = urlParams.get('auth_token');
    const currency = urlParams.get('currency');

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            operator: operatorId,
            auth_token: authToken,
            currency,
        }),
    };

    const requestUrl = getApiUrl(window.env.REACT_APP_HTTP_URL);

    return fetch(`${requestUrl}/api/auth`, requestOptions)
        .then(response => {
            return response.json();
        }).then((result) => result.data)
}